const DocumentsDetails = ({ taskData, customFieldValues}) => {
    if (!taskData || !taskData.custom_fields) {
      return <p>Loading Documents</p>;
    }
    const attachments = taskData.custom_fields.filter((field) =>
      field.id in customFieldValues && field.type === 'attachment'
    );
    if (!attachments || attachments.length ===0) {
      return <p>Loading Attachments</p>;
    }


  const tmsAttachments = attachments.filter(
    (attachment) => {
      const name = customFieldValues[attachment.id]?.toUpperCase();
      return name === "BOL" || name === "POD";
    }
  );

  const regularAttachments = attachments.filter(
    (attachment) => !tmsAttachments.includes(attachment)
  );

  const renderAttachments = (attachmentList) =>
    attachmentList.map((attachment, index) => (
      <div key={index} style={{ marginBottom: "15px" }}>
        <h4 style={{ marginBottom: "5px", fontWeight: "bold" }}>
          {customFieldValues[attachment.id]}
        </h4>
        <ul style={{ paddingLeft: "10px", margin: 0 }}>
          {attachment.value && attachment.value.length > 0 ? (
            attachment.value.map((file, fileIndex) => (
              <li
                key={fileIndex}
                style={{ listStyle: "none", paddingBottom: "5px" }}
              >
                <a
                  href={file.url_w_query}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#1976d2", fontWeight: "500" }}
                >
                  {`Document ${fileIndex + 1}`}
                </a>
              </li>
            ))
          ) : (
            <p style={{ color: "#777", fontStyle: "italic" }}>No files available</p>
          )}
        </ul>
      </div>
    ));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "20px",
        padding: "15px",
      }}
    >
      <div style={{ flex: 1 }}>
        {renderAttachments(regularAttachments)}
      </div>

      <div style={{ flex: 1 }}>
        {renderAttachments(tmsAttachments)}
      </div>
    </div>
  );
};
export default DocumentsDetails;
